import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
import Slider from '../general/Slider';
import TestimonialItem from '../utils/TestimonialItem'
import Routes from '../../../routes';

const styles = StyleSheet.create({
    title: {
        color: '#193f83',
        fontWeight: 700
    },
    bg:{
        backgroundColor: '#d4e8f5'
    }
});




function mapStateToProps(state) {
    return {

    };
}

class Testimonials extends Component {
    
    render() {

        const testimonios = [

            {
                photo: "//lh4.googleusercontent.com/-5axRdoX9flU/AAAAAAAAAAI/AAAAAAAAAAA/WtyX_RqXRLE/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Irving Gutierrez",
                quote: "Experiencia magnífica, muy buen servicio, pude encontrar el lugar indicado para mis pertenencias.",
                rating: 5
            },
            {
                photo: "//lh4.googleusercontent.com/-SH24UrMc6mA/AAAAAAAAAAI/AAAAAAAAAAA/sCyGBRdcE7w/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Leonardo Rodríguez",
                quote: "Excelente servicio y una súper atención!! Lo recomiendo totalmente",
                rating: 5
            },
            {
                photo: "//lh4.googleusercontent.com/-Hx4v7GTFiiY/AAAAAAAAAAI/AAAAAAAAAAA/iY0yYOQWDQI/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Christian Corza",
                quote: "Encontré un lugar donde guardar mis muebles, mucho más barato que en cualquiera minibodega comercial",
                rating: 5
            },
            {
                photo: "//lh4.googleusercontent.com/-u3HL0IilSnQ/AAAAAAAAAAI/AAAAAAAAAAA/fT9FRJqV7Z0/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Clouds Ejuice",
                quote: "Rentamos un espacio en una bodega, solución practica. Mubit nos facilito todos los tramites.",
                rating: 5
            },
            {
                photo: "//lh4.googleusercontent.com/-OENsYHr_Y4Y/AAAAAAAAAAI/AAAAAAAAAAA/rCkhFdg3QTY/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Alvaro N I",
                quote: "Excelente servicio y atención al cliente, totalmente recomendado!",
                rating: 5
            },
            {
                photo: "//lh4.googleusercontent.com/-4wRDVvFTdfM/AAAAAAAAAAI/AAAAAAAAAAA/B_N-AZj2Ln8/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Alejandra Cardenas Monroy",
                quote: "Increíble servicio :)",
                rating: 5
            },
            {
                photo: "https://lh4.googleusercontent.com/-CkoMuyMd9Pk/AAAAAAAAAAI/AAAAAAAAAAA/blnTwn3YPB4/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Azucena Galindo",
                quote: "Excelente servicio y muy profesional, atendieron todas mis dudas y me resolvieron al momento, mantienen una excelente comunicación con el cliente.",
                rating: 5
            },
            {
                photo: "https://lh3.googleusercontent.com/-zRrOUKTgQFg/AAAAAAAAAAI/AAAAAAAAAAA/KBG4AQThpLk/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Dannya Ponce de León",
                quote: "Muy atentos, puntuales y siempre están en contacto por cualquier duda que te surga!! Buenos precios !!",
                rating: 5
            },
            {
                photo: "https://lh3.googleusercontent.com/-4hcY0XS6zQI/AAAAAAAAAAI/AAAAAAAAAAA/DrtHdc97sLk/w100-h100-p-rp-mo-br100/photo.jpg",
                username: "Daniela Benavides",
                quote: "Super seguro, confiable, respuestas rápidas.. Te sacan del apuro y nada caro.",
                rating: 5
            },

            

        ]

        return (
            <Container fluid className={css(styles.bg)+" py-3"}>
                <Container>
                    <Row className="my-5">
                        <Col xs={12} md={12} lg={2} className=" d-flex align-items-center justify-content-center">
                            <h2 className={css(styles.title)}>
                                Hicimos lo imposible, posible.
                            </h2>
                        </Col>
                        <Col xs={12} md={12} lg={10} className="p-0 my-5">
                            <div  >    
                                <Slider >
                                    {
                                        testimonios.map( (testimonio) => {
                                            return <TestimonialItem {...testimonio} />
                                        })
                                    }
                                </Slider>
                            </div>
                        </Col>
                    </Row>
                </Container>
                
            </Container>
        );
    }
}

export default connect(
    mapStateToProps,
)(Testimonials);